import {User}									from '../user/interface';
import {ApiAddressState, ApiSetMainAddressState,
	ApiDeleteAddressState}						from './interface';

import * as API									from '../../ressources/API';


export default {
	getAddressApi: async (user: User) => {
		const response = await API.getAddress(user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	postAddressApi: async (data: ApiAddressState) => {
		const response = await API.postAddress(data.data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	putAddressApi: async (data: ApiAddressState) => {
		if (!data.idAddress)
			return;
		const response = await API.putAddress(data.idAddress, data.data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	setMainAddressApi: async (data: ApiSetMainAddressState) => {
		const response = await API.setMainAddress(data.idAddress, data.dataName, data.user);
		if (!response || !response.status)
			return {dataName: data.dataName, data: null};
		return {dataName: data.dataName, data: response.data};
	},
	deleteAddressApi: async (data: ApiDeleteAddressState) => {
		const response = await API.deleteAddress(data.idAddress, data.user);
		if (!response || !response.status)
			return null;
		return data.idAddress;
	}
};
